<template>
  <div class="upload-img-box">
    <div class="upload" :style="`width: ${width}px; height: ${height}px;`">
      <div class="input-box" @click="handleUpload">
        <input ref="upload-input" class="upload-input" type="file" :accept="accept" @change="handleClick">
        <el-image v-if="imageUrl" :src="imageUrl" class="img" fit="contain" />
        <i v-else-if="loading" class="el-icon-loading avatar-uploader-icon"></i>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </div>
      <div v-if="imageUrl" class="cover-box" :style="`width: ${width}px; height: ${height}px;`">
        <div class="btn-box">
          <i class="iconfont icon-mimakejian" @click="showProview = true" title="图片预览"></i>
          <i class="iconfont icon-bianji" @click="handleUpload" title="修改"></i>
          <i class="iconfont icon-shanchu" @click="onDelete" title="删除"></i>
        </div>
      </div>
    </div>
    <div class="hint" :style="`left: ${width}px;`">
      <div class="text">{{desc}}</div>
    </div>
    <el-dialog title="图片预览" :visible="showProview" @close="showProview = false" width="50%">
      <div class="proview-dialog">
        <el-image :src="imageUrl" class="proview-img" fit="contain" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "uploadImg",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    uploadUrl: {
      default() {
        return ''
      }
    },
    maxSize: {
      type: Number,
      default() {
        return 2
      }
    },
    width: {
      type: Number,
      default() {
        return 150
      }
    },
    height: {
      type: Number,
      default() {
        return 150
      }
    },
    desc: {
      type: String,
      default() {
        return '建议上传jpg、png、jpeg格式的图片'
      }
    },
    accept: {
      type: String,
      default() {
        return '.jpg, .png, .jpeg'
      }
    }
  },
  data() {
    return {
      loading: false,
      imageUrl: null,
      showProview: false,
    };
  },
  created() {
    if(typeof(this.uploadUrl) != 'object') {
      this.imageUrl = this.uploadUrl
    }
  },
  methods: {
    // 点击上传
    handleUpload() {
      this.$refs['upload-input'].click()
    },

    // 图片上传事件
    handleClick(e) {
      this.loading = true
      const files = e.target.files
      const File = files[0]
      const check = this.beforeUpload(File) // 上传前校验
      if (!File || !check) {
        this.loading = false
        return
      }

      const reader = new FileReader()
      reader.readAsDataURL(File)
      reader.onload = () => {
        const src = reader.result;
        this.imageUrl = src
        this.$emit('getUploadFile', File, this.name)
        this.loading = false
      }
    },


    // 上传前校验
    beforeUpload(file) {
      if (!file) {
        return
      }
      let imgType = []
      this.accept.split(', ').forEach(item => {
        imgType.push('image/' + item.split('.')[1])
      })

      const checkImg = imgType.indexOf(file.type) > -1
      const checkSize = file.size / 1024 / 1024 < this.maxSize;

      if (!checkImg) {
        this.$baseMessage(`请上传${this.accept}类型文件`, 'error');
      }
      if (!checkSize) {
        this.$baseMessage('上传图片大小不能超过 ' + this.maxSize + 'MB', 'error');
      }
      return checkImg && checkSize;
    },

    // 预览
    onProview() {

    },

    // 点击删除按钮
    onDelete() {
      this.imageUrl = null
      this.$refs['upload-input'].value = null
      this.$emit('getUploadFile', '', this.name)
    }

  },
  watch: {
    uploadUrl() {
      if(typeof(this.uploadUrl) != 'object') {
        this.imageUrl = this.uploadUrl
      }
    }
  }
};
</script>

<style lang="scss">
.upload-img-box {
  position: relative;
  display: flex;

  .upload {
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    overflow: hidden;
    position: relative;

    &:hover {
      border-color: $base-color-green;
    }

    .input-box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .upload-input {
        display: none;
        z-index: -9999;
      }

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .cover-box {
      position: absolute;
      left: 0;
      top: 0;
      background-color: #000;
      opacity: 0;
      display: flex;
      align-items: center;

      &:hover {
        opacity: 0.8;
      }

      .btn-box {
        width: 100%;
        display: flex;
        justify-content: space-evenly;

        .iconfont {
          font-size: 18px;
          color: #fff;
          cursor: pointer;

          &:hover {
            color: #05C8AF;
          }
        }
      }
    }
  }


  .avatar-uploader-icon {
    font-size: 30px;
    font-weight: 700;
    color: #cccccc;
  }

  .hint {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .text {
      line-height: 17px;
      font-size: 12px;
      color: #999999;
      margin-left: 10px;
    }
  }

  .proview-dialog {
    text-align: center;
    .proview-img {
      width: 100%;
    }
  }
}
</style>
